import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { RuleAndPolicySearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/equipment/items/$id/_detail/rule-and-policy/')({
  validateSearch: zodValidator(RuleAndPolicySearchSchema)
});